// extracted by mini-css-extract-plugin
export default {"container":"TextCellInput_container__1+A1Z"};